export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11985.e5d2a8b8.jpg";